import { render } from "./Outcomes.vue?vue&type=template&id=26167db2&scoped=true"
import script from "./Outcomes.vue?vue&type=script&lang=js"
export * from "./Outcomes.vue?vue&type=script&lang=js"

import "./Outcomes.vue?vue&type=style&index=0&id=26167db2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/doineedavpn.com/doineedavpn.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26167db2"]])

export default __exports__